import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '@doa/core/services/global.service';

@Component({
  selector: 'doa-session-expired',
  templateUrl: './session-expired.component.html',
  styleUrl: './session-expired.component.scss'
})
export class SessionExpiredComponent {
  constructor(private router: Router,
              private globalService: GlobalService
  ) {}

  goToHome(): void {
    // Clear any stored tokens and redirect to home for re-authentication
    //this.globalService.clearTokens();
    window.location.href = "/";
  }
}
